import React, { useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import SignatureCanvas from "react-signature-canvas";
import { api } from "./api";
import FooterLogo from "./FooterLogo";

export default function VerifySignature() {

    const navigate = useNavigate();
    const { state } = useLocation();

    const sigCanvas = useRef(null);

    const [saving, setSaving] = useState(false);
    const [showSuccess, setShowSuccess] = useState(false);

    if (!state) {
        return <div>No patient loaded.</div>;
    }

    const {
        patient,
        requestNumber,
        verifyId
    } = state;

    const clearSignature = () => {
        sigCanvas.current.clear();
    };

    const handleSubmit = async () => {

        if (sigCanvas.current.isEmpty()) {
            console.log("No signature");
            return;
        }

        try {

            setSaving(true);

            await api.put(
                `/verify/patient/${requestNumber}`,
                patient
            );

            await api.post("/save-signature", {
                requestNumber,
                signatureData: sigCanvas.current
                    .getTrimmedCanvas()
                    .toDataURL("image/png")
            });

            await api.post(
                `/verify/complete/${verifyId}`
            );

            setShowSuccess(true);

        }
        catch (err) {

            console.error(err);

            alert(
                err.response?.data?.message ||
                "Unable to save."
            );

        }
        finally {

            setSaving(false);

        }

    };

    return (

        <div
            className="min-h-screen flex flex-col"
            style={{
                backgroundImage:
                    "radial-gradient(circle at top left, #A8A8A8, #8C8C8C, #85D3DE, #8DDFEB)",
            }}
        >

            <div className="flex-1 flex items-center justify-center">

                <div className="bg-white/30 backdrop-blur-md rounded-xl shadow-xl p-10 border border-white/40 w-[900px]">

                    <div className="text-center">

                        <img
                            src="/InfoMedi_logo.png"
                            alt="Logo"
                            className="h-20 mx-auto mb-6"
                        />

                        <h1 className="text-4xl font-bold text-blue-800">
                            Patient Verification
                        </h1>

                        <p className="mt-4 text-gray-700">
                            Please sign below to confirm your information.
                        </p>

                    </div>

                    <div className="mt-8 flex justify-center">

                        <SignatureCanvas
                            ref={sigCanvas}
                            penColor="black"
                            canvasProps={{
                                width: 800,
                                height: 400,
                                className:
                                    "border-2 border-gray-400 rounded-lg bg-white"
                            }}
                        />

                    </div>

                    <div className="flex justify-between mt-8">

                        <button
                            onClick={() => navigate(-1)}
                            className="bg-gray-500 hover:bg-gray-600 text-white px-8 py-3 rounded-lg"
                        >
                            BACK
                        </button>

                        <button
                            onClick={clearSignature}
                            className="bg-yellow-600 hover:bg-yellow-700 text-white px-8 py-3 rounded-lg"
                        >
                            CLEAR
                        </button>

                        <button
                            disabled={saving}
                            onClick={handleSubmit}
                            className="bg-blue-700 hover:bg-blue-800 text-white px-8 py-3 rounded-lg"
                        >
                            {saving ? "Saving..." : "SUBMIT"}
                        </button>

                    </div>

                </div>

            </div>

            {showSuccess && (

                <div className="fixed inset-0 bg-black/50 flex items-center justify-center">

                    <div className="bg-white rounded-xl p-8 shadow-xl text-center w-[450px]">

                        <div className="text-6xl mb-4">
                            ✅
                        </div>

                        <h2 className="text-3xl font-bold text-green-700">
                            Thank You
                        </h2>

                        <p className="mt-4 text-gray-700">
                            Your information has been successfully updated.
                        </p>

                        <button
                            onClick={() => navigate("/verify")}
                            className="mt-8 bg-blue-700 hover:bg-blue-800 text-white px-10 py-3 rounded-lg"
                        >
                            OK
                        </button>

                    </div>

                </div>

            )}

            <FooterLogo />

        </div>

    );

}